import MaskJson from "./mask.json";

export const findMaskByCountry = (country) => {
  return MaskJson.filter((mask) => {
    return mask.cc === country || mask.cc.includes(country);
  })[0];
};
